import { Pipe, PipeTransform, Inject } from '@angular/core';

// Simple translate pipe to pass through calls to angular $translate
@Pipe({
  name: 'bytesSize'
})
export class BytesSizePipe implements PipeTransform {

  constructor(@Inject('$translate') private $translate) {
  }
  transform(bytes: number, precision: number): string {
    if (typeof (precision) === 'undefined') {
      precision = 1;
    }
    const units = [
      this.$translate.instant('bytes.bytes'),
      this.$translate.instant('bytes.kilobytes'),
      this.$translate.instant('bytes.megabytes'),
      this.$translate.instant('bytes.gigabytes'),
    ];
    const number = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, Math.floor(number))).toFixed(precision)} ${units[number]}`;
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/pipes/bytes-size.pipe.ts